module.exports = __webpack_public_path__ + "img/trash.57d0d621.svg";